import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import {
  mapWidgetTitleSettings,
  WidgetBackground,
  WidgetTitle
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { useRect } from 'react-use-rect';
import { meta } from '../meta';
import { Deactivation, EmptyState } from './components';
import { JobFilters, useJobFilters } from './filters';
import { Layout, useLayout } from './layout';
import { PopupComponent as Popup } from './popup';

export function Widget() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);
  const {
    widgetBackground,
    widgetHorizontalPadding,
    widgetVerticalPadding,
    widgetWidth
  } = settings;

  const {
    filteredJobs,
    processedJobs,
    currentFiltersStyle,
    hasActiveFiltersOrSearch
  } = useJobFilters();

  const isSidePanel = currentFiltersStyle === 'sidePanel';
  const currentJobs = isSidePanel ? processedJobs : filteredJobs;

  const shouldShowEmptyState = hasActiveFiltersOrSearch && !currentJobs.length;

  const { setWidgetWidth } = useLayout();

  const [ref] = useRect(
    ({ width }) => {
      if (width) {
        setWidgetWidth(width);
      }
    },
    { resize: true }
  );

  const Content = shouldShowEmptyState ? (
    <EmptyState />
  ) : (
    <Layout jobs={currentJobs} />
  );

  return (
    <Container>
      <Deactivation childrenRef={ref}>
        <WidgetBackground
          {...widgetBackground}
          width={widgetWidth}
          horizontalPadding={widgetHorizontalPadding}
          verticalPadding={widgetVerticalPadding}
          style={{
            fontFamily: settings.font?.value
          }}
        >
          <WidgetTitle {...mapWidgetTitleSettings(settings)} />

          <Show when={!isSidePanel}>
            <JobFilters />
          </Show>

          <Show when={isSidePanel} fallback={Content}>
            <SidePanelWrapper>
              <JobFilters />

              <SidePanelContent>{Content}</SidePanelContent>
            </SidePanelWrapper>
          </Show>

          <FreeLink
            {...freeLinkSettings}
            appAlias={meta.appAlias}
            appName={meta.appName}
            style={{
              link: {
                marginTop: '20px'
              }
            }}
          />
        </WidgetBackground>
      </Deactivation>

      <Popup jobs={filteredJobs} />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;

const SidePanelWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  margin-top: 12px;
`;

const SidePanelContent = styled.div`
  flex: 1;
`;
